export default {
    msg: state => state.msg
};
